/**
 * Copyright © 2026 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

const BASE = "account/personal-details";

export const PERSONAL_DETAILS_PATHS = {
  BASE,
} as const;

export const PERSONAL_DETAILS_ROUTES = {
  BASE: `/${PERSONAL_DETAILS_PATHS.BASE}`,
  ROOT: `/${PERSONAL_DETAILS_PATHS.BASE}/*`,
} as const;
